import type { IRoute } from '@/router/helpers'
import { BasicLayout } from '@/layouts'

const route: IRoute = {
  path: 'bulletin',
  Component: BasicLayout,
  children: [
    {
      path: '',
      Component: lazy(() => import('@/views/bulletin/index')),
      meta: { title: '公告列表' },
    },
    {
      path: ':id',
      Component: lazy(() => import('@/views/bulletin/detail')),
      meta: { title: '公告详情' },
    },
  ],
}

export default route
